









































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ADD_CORRECT_ANSWER, ADD_WRONG_ANSWER } from '../../store/actions.type';
import { QuizQuestion } from '../../common/types';

@Component
export default class BudtenderQuiz extends Vue {
  @Prop({ default: 'Budtender Quiz' }) quizTitle!: string;

  @Prop() question!: QuizQuestion;

  @Prop({ default: 0 }) currentQuestionNumber!: number;

  // Data
  selectedAnswer = -1;

  userIsCorrect = false;

  resultText = '';

  questionAnswered = false;

  currentQuestion: QuizQuestion | null = null;

  // Methods
  mounted(): void {
    this.currentQuestion = this.question;
  }

  answerSubmitted() {
    if (!this.currentQuestion || this.selectedAnswer < 0) {
      return;
    }
    const userAnswer = this.currentQuestion.answers[this.selectedAnswer];
    this.questionAnswered = true;
    if (userAnswer === this.currentQuestion.answer) {
      this.userIsCorrect = true;
      this.resultText = `Correct! ${this.currentQuestion.correctText}`;
      this.$store.dispatch(ADD_CORRECT_ANSWER);
      return;
    }
    this.userIsCorrect = false;
    this.resultText = `Nope! ${this.currentQuestion.wrongText}`;
    this.$store.dispatch(ADD_WRONG_ANSWER);
  }

  moveToNextQuestion() {
    this.$emit('answerSubmitted');
  }

  answerIcon(index) {
    const letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
    const currentLetter = letters[index];
    return `mdi-alpha-${currentLetter}-circle-outline`;
  }

  numberIcon() {
    return `numeric-${this.currentQuestionNumber}-circle`;
  }
}
